import React, { Component } from 'react';
import {Route, Switch} from 'react-router-dom';

import Sidebar from './containers/Sidebar';
import Months from './containers/Months';
import Month from './containers/Month';
import Products from './containers/Products';
import Product from './containers/Product';
import Deliveries from './containers/Deliveries';
import Delivery from './containers/Delivery'
import ExtraDelivery from './containers/ExtraDelivery'
import Customers from './containers/Customers';
import Customer from './containers/Customer';
import CreateCustomer from './containers/CreateCustomer'
import CreateCustomerSuccess from './containers/CreateCustomerSuccess'
import SignIn from './containers/SignIn';
import Order from './containers/Order'

import '../../admin.css'

class Admin extends Component{
  constructor(){
    super();
    this.state = {
      isAuthenticated: false
    }

    this.checkIfAuthenticated = this.checkIfAuthenticated.bind(this)
    this.toggleAuthenticate = this.toggleAuthenticate.bind(this)
  }

  toggleAuthenticate() {
    this.setState(prevState => ({isAuthenticated: !prevState.isAuthenticated}))
  }

  checkIfAuthenticated() {
    if (!this.state.isAuthenticated) {
      const token = localStorage.getItem("admin-token")
      if (token === null) {
        this.props.history.push('/backoffice/login')
        return false
      } else{
        this.toggleAuthenticate()
      }
      return true
    } else {
      return false
    }
  }

  componentDidMount() {
    this.checkIfAuthenticated()
  }

  render() {
    return(
      <div className="Admin">
        {
          this.state.isAuthenticated
          ?
          <div className="Admin-container">
            <Route path="/backoffice" render={(props) => <Sidebar {...props}
              toggleAuthenticate={this.toggleAuthenticate} />} />
            <Switch>
              <Route exact path="/backoffice/months"
                render={(props) =>
                  <Months
                    isAuthenticated={this.state.isAuthenticated}
                    {...props}
                    />
                }
              />
              <Route exact path="/backoffice/months/:id"
                render={(props) =>
                  <Month
                    isAuthenticated={this.state.isAuthenticated}
                    {...props}
                    />
                }
              />
              <Route exact path="/backoffice/products" render={(props) =>
                  <Products checkIfAuthenticated={this.checkIfAuthenticated} />} />
              <Route path="/backoffice/products/:id"
                render={(props) =>
                  <Product
                    checkIfAuthenticated={this.checkIfAuthenticated}
                    {...props} />
                }
              />
              <Route exact path="/backoffice/deliveries" render={(props) =>
                <Deliveries checkIfAuthenticated={this.checkIfAuthenticated} />}/>
              <Route exact path="/backoffice/deliveries/extra" render={(props) =>
                <ExtraDelivery checkIfAuthenticated={this.checkIfAuthenticated} />}/>
              <Route path="/backoffice/deliveries/:id" render={(props) =>
                <Delivery
                  checkIfAuthenticated={this.checkIfAuthenticated}
                  {...props}
                  />
              }/>
            <Route exact path="/backoffice/customers/create" render={(props) =>
                <CreateCustomer checkIfAuthenticated={this.checkIfAuthenticated} />}
              />
            <Route exact path="/backoffice/customers/create/success/:id" render={(props) =>
                <CreateCustomerSuccess checkIfAuthenticated={this.checkIfAuthenticated} />}
              />
              <Route exact path="/backoffice/customers" render={(props) =>
                <Customers checkIfAuthenticated={this.checkIfAuthenticated} />}
              />
              <Route path="/backoffice/customers/:id" render={(props) =>
                <Customer
                  checkIfAuthenticated={this.checkIfAuthenticated}
                  {...props} />}
              />
              <Route exact path="/backoffice/order/:id"
                render={(props) =>
                  <Order
                    isAuthenticated={this.state.isAuthenticated}
                    {...props}
                    />
                }
              />
            </Switch>
          </div>
          :
          <Route path="/backoffice/login" render={(props) => <SignIn
              toggleAuthenticate={this.toggleAuthenticate} {...props}/>} />
        }
      </div>
    )
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/containers/admin/Admin.jsx